export const BrandType = {
  Restaurant: 0,
  Retail: 1,
  FieldService: 2
} as const;

export type BrandType = (typeof BrandType)[keyof typeof BrandType];